module.exports = __webpack_public_path__ + "img/2-12.86bbeaff.png";